import { useContext } from "react";
import { renderedContext } from "../context/context";
import { IConfig } from "./Render";
export const Img = ({className, id, src, style, children, draggable}:IConfig)=>
{
    draggable=(draggable==null)?false:draggable;
    // Shown, not played (the quiz builder's cards and its preview): a picture that is part of the
    // answer - one to drag onto a shape, into a group - stays where it is.
    const state: any = useContext(renderedContext);
    if (state?.readOnly === true) draggable = false;
    return (
        <img id={id} className={className} style={style} src={src} draggable={draggable}></img>
    );
}